document.addEventListener('DOMContentLoaded', () => {
  /* Deactivate dawn theme cart drawer */
  const stopDrawer = () => {
    const Drawer = customElements.get('cart-drawer');
    if (Drawer?.prototype?.open) Drawer.prototype.open = function () {};
  };
  stopDrawer();
  setTimeout(stopDrawer, 0);
  setTimeout(stopDrawer, 250);

  const SELECTOR = '.zrx-cart-items';

  let el = null;
  let targetTop = 0;
  let rafId = 0;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  const startAnim = () => {
    if (rafId) return;

    const tick = () => {
      rafId = 0;
      if (!el) return;

      const maxTop = el.scrollHeight - el.clientHeight;
      targetTop = clamp(targetTop, 0, Math.max(0, maxTop));

      const current = el.scrollTop;
      const diff = targetTop - current;

      // If close enough, snap and stop
      if (Math.abs(diff) < 0.5) {
        el.scrollTop = targetTop;
        return;
      }

      // Ease toward target (drag-like)
      el.scrollTop = current + diff * 0.22;

      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
  };

  const onWheelCapture = (e) => {
    if (!el) return;

    // Only when wheel is over the element (Shadow DOM safe)
    const path = e.composedPath?.() || [];
    if (!(path.includes(el) || el.contains(e.target))) return;

    // Only hijack if it can actually scroll
    if (el.scrollHeight <= el.clientHeight) return;

    // Stop background/page scroll
    e.preventDefault();
    e.stopPropagation();

    // Accumulate wheel into a target scroll position
    targetTop = el.scrollTop + e.deltaY;
    startAnim();
  };

  const attach = (found) => {
    if (el === found) return;
    el = found;
    targetTop = el.scrollTop;

    // console.log('✅ drag-like wheel scrolling attached to', el);

    // Capture wheel before the browser/page handles it
    document.addEventListener('wheel', onWheelCapture, {
      capture: true,
      passive: false,
    });
  };

  const tryFind = () => {
    const found = document.querySelector(SELECTOR);
    if (found) attach(found);
  };

  // Initial attempt + observer for delayed insertion
  tryFind();
  const obs = new MutationObserver(() => {
    if (!el) tryFind();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // console.log('👀 Observing DOM for', SELECTOR);
});


